import React, { useState } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import Header from "../Header";
import BaseContainerDividingLineRHSSidebar from "../BaseContainerDividingLineRHSSidebar";
import RegisteredButton from "../RegisteredButton";
import NonRegisteredButton from "../NonRegisteredButton";
import rect6518 from "../../img/rectangle-6518@2x.svg"
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import MultiSelectDropdown from "../MultiSelectDropdown";
import TFSAAgeDropdown from "../TFSAAgeDropdown";
import GrowthIndexDropdown from "../GrowthIndexDropdown";
import logo from "../../img/group-6@2x.svg";
import "./NonRegisteredPage.css";

const NonRegisteredPage = () => {
    const [totalNonReg, setTotalNonReg] = useState("");
    const [annualContribution, setAnnualContribution] = useState('')
    const [age, setAge] = useState('');
    const [inflation, setInflation] = useState('');

    const { user } = useAuth0();

    function getAge(age){
        setAge(age);
        return age;
    }

    function getGrowthIndex(inflation){
        setInflation(inflation);
        return inflation;
    }

    const multiList = ["Mutual Funds","ETF's","Bonds","Real Estate","GIC","Insurace","Stocks","Crypto Currency"];

    const onSubmit = (e) => {
        e.preventDefault();
        console.log('Non Reg: ', totalNonReg, annualContribution, age, inflation)
        axios.get(`http://localhost:4000/NON_REGISTERED_INVESTMENTS/add?NonRegisteredInvestmentID=${user.sub}&totalValue=${totalNonReg}&annualCont=${annualContribution}&inflation=${inflation}&stopAge=${age}`)
        .then(response => {
            console.log(response)
        })
        .catch(error => {
            console.log(error)
        })
        
    }

    return (
        <div className="container-center-horizontal">
            <div className="investments-stocks-1 screen">
                <div className="flex-col-30">
                    <Header />
                    <div className="overlap-group6-2">
                        <BaseContainerDividingLineRHSSidebar />
                        <div className="investments-8 nunito-bold-black-30px">Investments</div>
                        <div className="overlap-group2-9 nunito-semi-bold-haiti-11-7px"></div>
                        <img className="clicked-icon" src={rect6518} />
                        <div className="rectangle-6440 border-1px-athens-gray-2"></div>
                        <div className="rectangle-6452-2 border-1px-athens-gray-2"></div>
                        <div className="change-plan">
                            <div className="change-plan-1 nunito-bold-black-20px">Non Registered</div>
                        </div>
                        <div className="annual-contribution nunito-semi-bold-oxford-blue-11-7px">What is the current total value?</div>
                        <form onSubmit={onSubmit}>
                            <input 
                                className="lif-total-value"
                                type="number"
                                placeholder="$"
                                onChange={(e) => {
                                    setTotalNonReg(e.target.value)                                }}
                            />
                            <div className="average-lif-deposit nunito-semi-bold-oxford-blue-11-7px">On average how much do you contribute annualy?</div>
                            <input
                                className="average-lif-value"
                                type='number'
                                placeholder="$"
                                onChange={(e) => {
                                    setAnnualContribution(e.target.value);
                                }}
                            />
                            <div className="contribution-age-stop nunito-semi-bold-oxford-blue-11-7px">At what age do you plan to stop contributing?</div>
                            <TFSAAgeDropdown getAgeData = {getAge} />
                            <div className="growth-index-lif">Would you like to set growth indexed to inflation?</div>
                            <GrowthIndexDropdown getIndexData = {getGrowthIndex} />
                            <button type="submit" className="save-button-tfsa">Save</button>
                        </form>
                        {/* <MultiSelectDropdown multiSelect={multiList} className="nonreg-dropdown"/> */}
                        <BackButton backPage="/investments" />
                        <NextButton nextPage="/expenses" />
                        <RegisteredButton className="nunito-bold-black-14px" />
                        <NonRegisteredButton className="nunito-bold-azure-radiance-14px" handLogoNon={logo} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NonRegisteredPage;